// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191835/js/" + chunkId + "." + {"44":"b2487202","225":"b05aa498","481":"57f7485d","486":"a503c198","770":"7a184fb8"}[chunkId] + ".0.42924053863520517.chunk.js";
};